import { loadHtml2Canvas } from 'utils/load-html2canvas'
import { buildSvgOnClone } from 'utils/svg-export-utils'

/**
 * Captures a chart's plot-area DOM node as a canvas — the same
 * `buildSvgOnClone` + `html2canvas-pro` pipeline `Chart.tsx`'s own "Copy
 * PNG"/"Download PNG" buttons already use (`buildSvgOnClone` pre-rasterizes
 * an SVG under a `[data-chart-export-root="true"]` marker when the chart
 * type needs it, and is a safe no-op otherwise), just returning the canvas
 * instead of copying to the clipboard or triggering a download.
 */
export const captureAskYogiChartCanvas = async (
  contentEl: HTMLDivElement | null,
): Promise<HTMLCanvasElement | null> => {
  if (!contentEl) return null
  const onclone = await buildSvgOnClone(contentEl)
  const html2canvas = await loadHtml2Canvas()
  return html2canvas(contentEl, {
    scale: 2,
    backgroundColor: '#ffffff',
    scrollY: -window.scrollY,
    ...(onclone ? { onclone } : {}),
  })
}
